export default "__VITE_ASSET__Dgm21K6S__"